'use client';

const HeroServiceDetailsHeader = (props) => {
	return (
		<div
			className="ptf-showcase-image image-overlay"
			style={{
				backgroundImage: `url(${props.imageUrl})`,
				...(props.style ?? {}),
			}}
		>
			<div className="ptf-showcase-slide h-[24rem]">
				<div className="container">
					<h1 className="fz-48 fz-48--lg lh-1 has-white-color text-center">
						{props.title ?? 'Service Details'}
					</h1>
				</div>
			</div>
		</div>
	);
};

export default HeroServiceDetailsHeader;
